import React from 'react';
import { Row, Col } from 'antd'
import richard from '../../assets/profiles/richard.jpg';

const intl = {
  quote: {
    'en': <div style={{ fontStyle: 'italic' }}>
      "We believe our clients are unique. Simply because not two tasks and no two problems are the same. There are no standard solutions nor any magic that can be applied or conjured up.
      We strive to meet our clients where they are. Our task is to identify beyond a doubt what exactly it is the client wish to address.
      It always requires a degree of challenging the client - their perception and assumptions and possibly their ideas around the solutions.
      <br /><br />
      Through dialogue and analysis, we seek to gain understanding, which will lead us to the most suitable solutions. Solutions that help the client achieve the desired outcome and goals."
    </div>,
    'dk': <div style={{ fontStyle: 'italic' }}>
      "Vi mener at vores klienter er helt særlige. Fordi der er ikke to problemstillinger eller opgaver, der er ens. Der er ingen standardløsninger eller noget magisk, vi kan trække op af tasken eller hive ned fra hylden. Vi møder vores klienter, der hvor de er og vores opgave er sammen med klienten at identificere helt entydigt, hvad opgaven er. Først derefter går vi i gang med at danne os et indtryk af hvorledes den kan løses –bedst muligt.
      <br /><br />
      Vi er fokuseret på at løse opgaven rigtigt – ikke nødvendigvis hurtigst eller nemmest, men mest optimalt for organisationen og dens fremadrettede evne til at handle i overensstemmelse med deres ønskede mål."
    </div>
  },
}
function Divider(props) {
  return (
    <Row style={{ backgroundColor: '#1abc9c', color: '#fff' }}>
      <Col sm={24} md={{ span: 16, offset: 4 }}>
        <Row gutter={24}>
          <Col sm={24} md={{ span: 24 }} style={{ position: 'relative', height: '100%' }}>
            <div
              style={{
                height: '100%',
                textAlign: 'center',
              }}
            >
              <div className="blog_block_content" style={{ marginTop: '-100px' }}>
                <div
                  style={{
                    position: 'relative',
                    height: '200px',
                    width: '200px',
                    margin: 'auto',
                    border: '7px solid #fff',
                    borderRadius: '50%',
                    background: `url(${richard}) no-repeat center center`,
                    backgroundSize: 'cover',
                  }}
                />
                <p
                  style={{
                    color: '#fff',
                    fontSize: '14px',
                    textOverflow: 'ellipsis',
                    padding: '30px 0'
                  }}
                >
                  {intl.quote[props.language]}
                  <div style={{
                    fontSize: '16px',
                    paddingTop: '20px'
                  }}><b style={{ color: '#1e3753' }}>Richard L. Hansen</b><br />Managing Partner</div>
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Divider;



// WEBPACK FOOTER //
// ./src/pages/Services/Divider.js